import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tag, Text } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { Fragment, useMemo } from 'react';
import { convertSortObjectToString } from '../../../utils/sort/convertSort';
import { filterFieldAssets, filterOperatorLabels, } from '../../filters/utils/definitions';
import { sortOptions } from '../../results/components/sort/searchResultsSort';
import styles from './savedSearchFilters.module.scss';
/**
 * Represents a component that is used to render the saved search filters that
 * are applied
 */
export const SavedSearchFilters = ({ variant, onRemove, params, }) => {
    const buildFilterSummary = (values) => {
        return values.map((item) => item.label || item.value).join(', ');
    };
    const filtersToRender = useMemo(() => {
        var _a;
        const { query, filters, strict, sort } = params;
        const items = [];
        // The search query is always first, if it exists
        if (query) {
            items.push({
                label: 'Keyword',
                value: query,
                onDelete: isEmpty(filters === null || filters === void 0 ? void 0 : filters.conditions)
                    ? undefined
                    : () => onRemove === null || onRemove === void 0 ? void 0 : onRemove('query'),
            }, {
                label: 'Exact match',
                value: strict ? 'Enabled' : 'Disabled',
            });
        }
        filters === null || filters === void 0 ? void 0 : filters.conditions.forEach(({ field, operator, values }) => {
            var _a, _b;
            items.push({
                label: (_b = (_a = filterFieldAssets[field]) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : field,
                operator: filterOperatorLabels[operator],
                value: buildFilterSummary(values),
                onDelete: () => onRemove === null || onRemove === void 0 ? void 0 : onRemove(field),
            });
        });
        items.push({
            label: 'Sort by',
            value: (sort &&
                ((_a = sortOptions.find(({ value }) => value === convertSortObjectToString(sort))) === null || _a === void 0 ? void 0 : _a.label)) ||
                'Relevance',
        });
        return items;
    }, [onRemove, params]);
    const rootClass = classnames(styles.filters, {
        [styles.filtersTags]: variant === 'tags',
    });
    return (_jsx("div", Object.assign({ className: rootClass }, { children: filtersToRender.map(({ value, label = '', operator, onDelete }, i) => {
            const isLast = i === filtersToRender.length - 1;
            const separator = !isLast ? (_jsx("span", Object.assign({ className: styles.filtersTextSeparator }, { children: "\u2022" }))) : ('');
            if (variant === 'tags') {
                return (_jsxs(Tag, Object.assign({ className: styles.filtersTag, onDelete: onDelete, noTruncation: true }, { children: [_jsx("span", Object.assign({ className: styles.filtersTagLabel }, { children: label })), operator && (_jsx("span", Object.assign({ className: styles.filtersTagOperator }, { children: operator }))), _jsx("span", { children: value })] }), label));
            }
            return (_jsxs(Fragment, { children: [_jsxs(Text.Paragraph, Object.assign({ variant: "4", color: "secondary", as: "span" }, { children: [label, ": ", operator, " ", value] })), separator] }, label));
        }) })));
};
